module.exports = {
  src: __webpack_public_path__ + "static/media/families_00023_thumb.d70a91d7.jpg",
  width: 382,
  height: 300,
  bytes: 24658,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/families_00023_thumb.d70a91d7.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/families/families_00023_thumb.jpg
// module id = 406
// module chunks = 0